import { Component, h, Prop, State, Element, Build } from '@stencil/core';
import Helmet from '@stencil/helmet';
import get from 'lodash/get'
import { SectionGallery, SectionRTE, SectionEvent, SectionArticle, SectionProduct, SectionHero, SectionCards, SectionOffsetGallery, SectionTestimonials, SectionFullGallery, SectionFormBrochure, SectionFormWarranty, SectionFormCompetition, SectionAssociations, SectionAssociationsCTA, Sections2ColCTA, SectionsContact, SectionTimeline, SectionContacts, SectionProductOwners, SectionDownloads } from '../../functional';
import { getSlug, getArticle, getEvent } from '../../shared/api'
import { seoPage, seoArticle, seoEvent } from '../../shared/seo'
import { ldArticle, ldBreadcrumb } from '../../shared/ldJson'
import state from '../../store/store'

@Component({
  tag: 'vw-page'
})
export class VwPage {
  @Element() el: HTMLElement;

  @Prop() list?: string;
  @Prop() slug: string;
  @State() content: Array<any> = [];
  @State() article: any;
  @State() event: any;
  @State() product: any;
  @State() ownerProduct: any;

  @State() seo: any;
  @State() jsonLD: Array<any> = [];


  async componentWillRender() {

    this.content = this.content.filter(() => false)
    this.article = null;
    this.event = null;
    this.product = null;
    this.ownerProduct = null;
    this.seo = {};
    this.jsonLD = this.jsonLD.filter(() => false);

    // SET canonical tag
    if (document.querySelector("link[rel='canonical']")) document.querySelector("link[rel='canonical']").setAttribute("href", document.URL)

    if (this.list == 'news') {
      const { data, status } = await getArticle(this.slug);
      if (status !== 200) return;
      this.content = get(data, 'data.attributes.Content') || []
      this.article = get(data, 'data.attributes')
      this.seo = seoArticle(data, state);
      this.jsonLD.push(ldBreadcrumb('news', this.seo))
      this.jsonLD.push(ldArticle(data, state));
    }
    else if (this.list == 'events') {
      const { data, status } = await getEvent(this.slug);
      if (status !== 200) return;
      this.content = get(data, 'data.attributes.Content') || []
      this.event = get(data, 'data.attributes')
      this.seo = seoEvent(data, state);
      this.jsonLD.push(ldBreadcrumb('events', this.seo))
    }
    else if (this.list == 'owners') {
      const { data, status } = await getSlug('owners/' + this.slug, get(state, 'browser.locale'));
      if (status !== 200) return;
      this.content = get(data, 'data.attributes.Content') || []
      this.ownerProduct = get(data, 'data.attributes.OwnerProduct.data') ? get(data, 'data.attributes.OwnerProduct') : null
      this.seo = seoPage(data, state);
      this.jsonLD.push(ldBreadcrumb('owners', this.seo))
    }
    else {
      const { data, status } = await getSlug(this.slug, get(state, 'browser.locale'));
      if (status !== 200) return;
      this.content = get(data, 'data.attributes.Content') || []
      this.product = get(data, 'data.attributes.Product.data') ? get(data, 'data.attributes.Product') : null
      this.seo = seoPage(data, state);

      if (this.product) {
        this.product.data.attributes.Slug = get(data, 'data.attributes.Slug')
        this.jsonLD.push(ldBreadcrumb('products', this.seo))
      } else {
        this.jsonLD.push(ldBreadcrumb(null, this.seo))
      }
    }
  }

  componentDidRender() {
    window.scrollTo(0, 0);

    if (Build.isBrowser) {
      // Vid
      const vid = document.querySelector('video')
      if (vid && vid.id !== 'qr-scanner') {
        document.querySelector('video').playbackRate = 0.6;
        var playPromise = document.querySelector('video').play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Automatic playback started!
          }).catch(function (error) {
            // Automatic playback failed.
            // TODO: Show a UI element to let the user manually start playback.
            console.error(error)
          });
        }
      }
    }
  }

  render() {

    if ((this.content || []).length == 0 && !this.article && !this.event) return (
      <div class="uk-position-relative uk-section">
        <div class="uk-container uk-container-small uk-padding-large uk-margin-xlarge uk-text-center uk-background-primary-striped uk-light">
          <h4 class="uk-heading-small wsio-gold uk-margin-small-bottom">404 Error</h4>
          <h1 class="uk-heading-xlarge uk-margin-remove-top uk-margin-medium-bottom">Page Not Found</h1>
          <a href="/" class="uk-position-relative uk-margin-top uk-button uk-button-text">Back to Home</a>
        </div>
      </div>
    )

    // FIXME: work out if key stuff is needed or another fix as its screwing with SSG

    const renderRoute = () =>
      <div id='vw-page' class="uk-position-relative">
        <div class="uk-container uk-container-large">
          <div style={{ 'border-bottom': '1px solid #f0f0f0' }} />
        </div>
        {this.article ? <div key={`SectionArticle-${new Date().toISOString}`}><SectionArticle data={this.article} /></div> : ''}
        {this.event ? <div key={`SectionEvent-${new Date().toISOString}`}><SectionEvent data={this.event} /></div> : ''}
        {this.product ? <div key={`SectionProduct-${new Date().toISOString}`}><SectionProduct data={this.product} /></div> : ''}
        {this.ownerProduct ? <div key={`SectionProductOwners-${new Date().toISOString}`}><SectionProductOwners data={this.ownerProduct} /></div> : ''}
        <div>{
          this.content.map((section) => {
            const { __component, id } = section;
            switch (__component) {
              case 'sections.hero': return <div key={`${__component}-${id}`}><SectionHero __component={__component} data={section} /></div>
              case 'sections.cards': return <div key={`${__component}-${id}`}><SectionCards __component={__component} data={section} /></div>
              case 'sections.offset-gallery': return <div key={`${__component}-${id}`}><SectionOffsetGallery __component={__component} data={section} /></div>
              case 'sections.testimonials': return <div key={`${__component}-${id}`}><SectionTestimonials __component={__component} data={section} /></div >
              case 'sections.gallery': return <div key={`${__component}-${id}`}><SectionFullGallery __component={__component} data={section} /></div >
              case 'sections.latest-videos': return <div key={`${__component}-${id}`}><app-dynamic-section __component={__component} data={section} /></div >
              case 'sections.associations': return <div key={`${__component}-${id}`}><SectionAssociations __component={__component} data={section} /></div >
              case 'sections.brands': return <div key={`${__component}-${id}`}><SectionAssociationsCTA __component={__component} data={section} /></div >
              case 'sections.products': return <div key={`${__component}-${id}`}><section-products __component={__component} data={section} /></div >
              case 'sections.cta': return <div key={`${__component}-${id}`}><Sections2ColCTA __component={__component} data={section} /></div >
              case 'sections.rte': return <div key={`${__component}-${id}`}><SectionRTE __component={__component} data={section} /></div >
              case 'sections.map': return <SectionsContact __component={__component} data={section} />
              case 'sections.contacts': return <div key={`${__component}-${id}`}><SectionContacts __component={__component} data={section} /></div >
              case 'sections.timeline': return <div key={`${__component}-${id}`}><SectionTimeline __component={__component} data={section} /></div >
              case 'sections.form-brochure': return <div key={`${__component}-${id}`}><SectionFormBrochure __component={__component} data={section} /></div >
              case 'sections.form-warranty': return <div key={`${__component}-${id}`}><SectionFormWarranty __component={__component} data={section} /></div>
              case 'sections.form-competition': return <div key={`${__component}-${id}`}><SectionFormCompetition __component={__component} data={section} /></div>
              case 'sections.downloads': return <div key={`${__component}-${id}`}><SectionDownloads __component={__component} data={section} /></div>
              case 'sections.masonry-gallery': return <div key={`${__component}-${id}`}><SectionGallery __component={__component} data={section} /></div>
            }
          })
        }
        </div>
      </div>

    return [
      <Helmet>
        <title>{get(this.seo, 'Title')}</title>
        <meta name="description" content={get(this.seo, 'Description')} />

        <meta name="twitter:card" content={get(this.seo, 'TwitterCard')} />
        <meta name="twitter:site" content={get(this.seo, 'TwitterSite')} />
        <meta name="twitter:creator" content={get(this.seo, 'TwitterCreator')} />
        <meta name="twitter:title" content={get(this.seo, 'Title')} />
        <meta name="twitter:description" content={get(this.seo, 'Description')} />
        <meta name="twitter:image" content={get(this.seo, 'Image')} />

        <meta property="og:url" content={document.URL} />
        <meta property="og:type" content={get(this.seo, 'Type')} />
        <meta property="og:title" content={get(this.seo, 'Title')} />
        <meta property="og:image" itemprop="image" content={get(this.seo, 'Image')} />
        <meta property="og:description" content={get(this.seo, 'Description')} />
        <meta property="og:site_name" content={get(this.seo, 'Brand')} />
        <meta property="article:publisher" content={get(this.seo, 'Publisher')} />
        <meta property="og:locale" content={get(state.browser, 'locale') || 'en'} />
        <script type="application/ld+json">{JSON.stringify(this.jsonLD)}</script>
      </Helmet>,
      renderRoute()
    ];
  }
}
